
import React, { useEffect, useState } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import emailjs from '@emailjs/browser';
import 'leaflet/dist/leaflet.css';
import './Contact.css';

// Définir l’icône rouge personnalisée
const redIcon = new L.Icon({
  iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41]
});

function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [isLoading, setIsLoading] = useState(false);
  const [status, setStatus] = useState(null);

  useEffect(() => {
    const handleScroll = () => {
      const header = document.querySelector('.header');
      if (window.scrollY > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);

    // Générer l'heure actuelle pour la variable {{time}}
    const currentTime = new Date().toLocaleString('fr-FR', {
      timeZone: 'Africa/Algiers',
      dateStyle: 'short',
      timeStyle: 'short'
    });

    // Envoyer l'e-mail avec EmailJS
    emailjs
      .send(
        'service_evuxgii', // Remplacez par votre ID de service EmailJS (ex: service_xxxxxx)
        'template_nvj5xzq', // Remplacez par votre ID de modèle EmailJS (ex: template_xxxxxx)
        {
          name: formData.name,
          email: formData.email,
          subject: formData.subject,
          message: formData.message,
          time: currentTime
        },
        'LsAHFEm43S7pbZuvr' // Remplacez par votre clé publique EmailJS (ex: user_xxxxxx)
      )
      .then(
        (result) => {
          console.log('Email sent successfully:', result.text);
          setStatus({ type: 'success', message: 'Message envoyé avec succès !' });
          setFormData({ name: '', email: '', subject: '', message: '' });
          setIsLoading(false);
          setTimeout(() => setStatus(null), 5000); // Efface le message après 5 secondes
        },
        (error) => {
          console.error('Error sending email:', error.text);
          setStatus({ type: 'error', message: 'Erreur lors de l’envoi du message. Veuillez réessayer.' });
          setIsLoading(false);
        }
      );
  };

  return (
    <div className="contact">
      <div className="imagecontact">
        <div className="image-text">
          <h1 style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '400' }}>
            Contactez-nous
          </h1>
          <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '100' }}>
            Contactez-nous dès aujourd’hui <span className="mobile-break"></span>afin que nous puissions adapter
          </p>
          <p style={{ fontFamily: "'Poppins', sans-serif", fontWeight: '100' }}>
            nos solutions à vos besoins spécifiques.
          </p>
        </div>
      </div>
      <div className="text-contact">
        <b>
          <h1 style={{ fontFamily: "'Poppins', sans-serif" }}>
            Prenez contact <span className="blue-text">avec nous</span>
          </h1>
        </b>
        <p>
          Des questions ? Nous sommes là<br />
          <br />
          des retours d’expérience ou prêt à initier un projet<br />
          <br />
          Notre équipe vous accompagne et vous soutient à chaque étape de votre projet.
        </p>
        <br />
        <br />
        <div className="form-wrapper">
          <form className="contact-form" onSubmit={handleSubmit}>
            <input
              type="text"
              name="name"
              placeholder="Nom&Prénom"
              required
              value={formData.name}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="text"
              name="subject"
              placeholder="Objet"
              required
              value={formData.subject}
              onChange={handleChange}
            />
            <textarea
              name="message"
              placeholder="Message"
              required
              rows="5"
              value={formData.message}
              onChange={handleChange}
            ></textarea>
            <button type="submit" disabled={isLoading}>
              {isLoading ? 'Envoi en cours...' : 'Envoyer un message'}
            </button>
          </form>
          {status && (
            <div className={`status-message ${status.type}`}>
              {status.message}
            </div>
          )}
        </div>
        <div className="map-container">
          <MapContainer center={[36.252566, 6.576123]} zoom={13} style={{ height: '400px', width: '100vw' }}>
            <TileLayer
              url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              attribution='© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[36.252566, 6.576123]} icon={redIcon}>
              <Popup>Startup Hub - Alger</Popup>
            </Marker>
          </MapContainer>
        </div>
        {isLoading && (
          <div className="loading-screen">
            <div className="loading-logo"></div>
          </div>
        )}
      </div>
    </div>
  );
}

export default Contact;